/* ROUGHCUT — the story page.
   ══════════════════════════════════════════════════════════════════════════
   Two jobs: drive the measuring tape, and draw the seams.

   ES5, like the rest of the theme's assets. */

(function () {
  'use strict';

  if (window.__rcWhyBooted) return;
  window.__rcWhyBooted = true;

  function boot() {
    var page = document.querySelector('.rc-why');
    if (!page) return;

    var reduced = false;
    try {
      reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {}

    /* ── the hourglass ───────────────────────────────────────────────────
       The sand is two polygons, recomputed as you scroll. Both bulbs are
       triangles, so the sand's surface gets narrower as the top drains and
       wider as the bottom fills — that taper is the whole reason it reads as
       sand rather than as a bar in a funny shape.

       Geometry, matching the SVG (viewBox 0 0 64 96):
         top bulb    y 13 → 47, x 15..49 at the top, 31..33 at the neck
         bottom bulb y 49 → 83, x 31..33 at the neck, 15..49 at the base
       Half-width shrinks by 16 units over 34 of height in both, so one
       ratio does both.  */
    var glass = page.querySelector('.rc-why__glass');
    if (glass) {
      var sandTop = glass.querySelector('.rc-why__sand--top');
      var sandBot = glass.querySelector('.rc-why__sand--bot');
      var stream  = glass.querySelector('.rc-why__stream');
      var TAPER = 16 / 34;          /* half-width lost per unit of height */

      var idle = null, ticking = false, wasDone = false;

      function draw(p) {
        /* top bulb: surface falls from y13 toward the neck at y47 */
        var ys = 13 + p * 34;
        var hw = 17 - (ys - 13) * TAPER;          /* half-width at the surface */
        sandTop.setAttribute('points',
          (32 - hw) + ',' + ys + ' ' + (32 + hw) + ',' + ys + ' 33,47 31,47');

        /* bottom bulb: surface rises from the base at y83 toward the neck */
        var yb = 83 - p * 34;
        var hb = 17 - (83 - yb) * TAPER;
        sandBot.setAttribute('points',
          (32 - hb) + ',' + yb + ' ' + (32 + hb) + ',' + yb + ' 49,83 15,83');

        /* the falling stream reaches from the neck down to the pile */
        stream.setAttribute('y', 47);
        stream.setAttribute('height', Math.max(0, yb - 47));
      }

      function onScroll() {
        ticking = false;
        var span = page.offsetHeight - window.innerHeight;
        if (span <= 0) return;

        var y = (window.pageYOffset || document.documentElement.scrollTop) - page.offsetTop;
        var p = y / span;
        p = p < 0 ? 0 : (p > 1 ? 1 : p);

        draw(p);
        glass.setAttribute('data-pct', Math.round(p * 100));

        /* Hidden until you've actually started reading — an hourglass showing
           zero progress the instant the page loads is just noise. */
        glass.classList.toggle('is-on', p > 0.015);

        /* Sand only pours while it's moving. */
        glass.classList.add('is-running');
        clearTimeout(idle);
        idle = setTimeout(function () { glass.classList.remove('is-running'); }, 220);

        /* The tip-over fires once, at the end. */
        var done = p > 0.995;
        if (done !== wasDone) { glass.classList.toggle('is-done', done); wasDone = done; }
      }

      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
      }, { passive: true });
      window.addEventListener('resize', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
      }, { passive: true });
      onScroll();
    }

    /* ── the seams ────────────────────────────────────────────────────────
       A stitch line that draws itself across the page as each section
       arrives. It's a dashed rule scaled from 0 on the x-axis, which on a
       sewing site reads as a seam being run rather than as a divider
       appearing.

       Drawn with its own observer rather than the site-wide reveal one,
       because these want a longer, slower travel than a normal reveal — a
       seam that snaps into place looks like a glitch. */
    if (!reduced && 'IntersectionObserver' in window) {
      var seams = page.querySelectorAll('.rc-why__seam');
      if (seams.length) {
        var io = new IntersectionObserver(function (entries) {
          for (var k = 0; k < entries.length; k++) {
            if (entries[k].isIntersecting) {
              entries[k].target.classList.add('is-sewn');
              io.unobserve(entries[k].target);
            }
          }
        }, { threshold: 0.2, rootMargin: '0px 0px -60px 0px' });
        for (var m = 0; m < seams.length; m++) io.observe(seams[m]);
      }
    } else {
      /* No observer, or motion turned down: the seams are decoration, so
         just draw them and move on. */
      var all = page.querySelectorAll('.rc-why__seam');
      for (var n = 0; n < all.length; n++) all[n].classList.add('is-sewn');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
